export default {
  TipoVeiculo: [
    { text: 'Carros', value: 'carros' },
    { text: 'Motos', value: 'motos' },
    { text: 'Caminhões', value: 'caminhoes' }
  ],
  GetMarcas (tipo) {
    return fetch('https://veiculos.fipe.org.br/api/veiculos/ConsultarMarcas?codigoTabelaReferencia=262&codigoTipoVeiculo=1', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
  }
}
